<form [formGroup]="vacancyForm" class="p-fluid grid" (ngSubmit)="save()">
  <div class="field grid">

    <div class="col-12 md:col-6 field">
      <label for="movementLocation" class="block mb-2 font-medium">{{ 'LOCAL' | translate }}</label>
      <p-dropdown
        inputId="movementLocation"
        formControlName="movementLocation"
        [options]="movementLocations"
        optionLabel="name"
        placeholder="Selecione o local"
        [showClear]="!isEditMode"
        appendTo="body"
        class="w-full">
      </p-dropdown>
    </div>

    <div class="col-12 md:col-6 field">
      <label for="code" class="block mb-2 font-medium">{{ 'VACANCY-CODE' | translate }}</label>
      <input pInputText
        id="code"
        formControlName="code"
        class="w-full"
        [maxlength]="codeMaxLength">
      <small *ngIf="selectedLocation?.prefixUse" class="prefix-hint">
        Prefixo {{ selectedLocation.abbreviation }} acrescentado automaticamente
      </small>
    </div>

    <div *ngIf="codeWithoutLocationPrefix" class="col-12 field">
      <small class="prefix-warning">
        O código {{ codeWithoutLocationPrefix.code }} não tem o prefixo {{ codeWithoutLocationPrefix.prefix }} do local.
        Mudar só largura/comprimento não altera a vaga; mudar código, tamanho máximo ou local grava o código com o
        prefixo ({{ codeWithoutLocationPrefix.prefix }}{{ vacancyForm.get('code').value }}).
      </small>
    </div>

    <div class="col-12 md:col-4 field">
      <label for="maxBoatLength" class="block mb-2 font-medium">Tam. Máximo (pés)</label>
      <p-inputNumber
        inputId="maxBoatLength"
        formControlName="maxBoatLength"
        [min]="0"
        [maxFractionDigits]="0"
        mode="decimal"
        [showButtons]="true"
        class="w-full">
      </p-inputNumber>
    </div>

    <div class="col-12 md:col-4 field">
      <label for="berthMapWidth" class="block mb-2 font-medium">{{ 'VACANCY-WIDTH' | translate }}</label>
      <p-inputNumber
        inputId="berthMapWidth"
        formControlName="berthMapWidth"
        [min]="0"
        [maxFractionDigits]="2"
        mode="decimal"
        [showButtons]="true"
        class="w-full">
      </p-inputNumber>
    </div>

    <div class="col-12 md:col-4 field">
      <label for="berthMapHeight" class="block mb-2 font-medium">{{ 'VACANCY-LENGTH' | translate }}</label>
      <p-inputNumber
        inputId="berthMapHeight"
        formControlName="berthMapHeight"
        [min]="0"
        [maxFractionDigits]="2"
        mode="decimal"
        [showButtons]="true"
        class="w-full">
      </p-inputNumber>
    </div>
  </div>

  <div class="col-12 flex justify-content-end gap-2 mt-4">
    <button class="easymarine danger" type="button" (click)="onCancel()">{{ 'CANCEL' | translate }}</button>
    <button class="easymarine primary" type="submit" [disabled]="!vacancyForm.valid">{{ 'SAVE' | translate }}</button>
  </div>
</form>
